/* eslint-disable @typescript-eslint/naming-convention */
import { ReactComponent as Airplane } from './svg/airplane.svg';
import { ReactComponent as Construction } from './svg/construction.svg';
import { ReactComponent as Close } from './svg/close.svg';
import { ReactComponent as Clock } from './svg/clock.svg';
import { ReactComponent as Checkmark } from './svg/checked.svg';
import { ReactComponent as ChevronDown } from './svg/chevron-down.svg';
import { ReactComponent as Globe } from './svg/globe.svg';
import { ReactComponent as Info } from './svg/info.svg';
import { ReactComponent as List } from './svg/list.svg';
import { ReactComponent as LocationArrow } from './svg/location-arrow.svg';
import { ReactComponent as Point } from './svg/point.svg';
import { ReactComponent as TrafficCone } from './svg/traffic-cone.svg';
import { ReactComponent as Umbrella } from './svg/umbrella.svg';

export const Icon = {
  Airplane,
  Construction,
  Close,
  Clock,
  Checkmark,
  ChevronDown,
  TrafficCone,
  Info,
  List,
  LocationArrow,
  Point,
  Umbrella,
  Globe,
};
